const mutations = {
  setViewPortSize(state, value) {
    state.viewPortSize = value;
  },
  setGlobalToaster(state, value) {
    state.globalToaster = value;
  },
  setGlobalSpinnerShow(state, value) {
    state.globalSpinnerShow = value;
  },
  setResizeWidth(state, value) {
    state.resizeWidth = value;
  },
  setAgencies(state, value) {
    state.agencies = value;
  },
  setCaseManagers(state, value) {
    state.caseManagers = value;
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js